import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=2fb2aa33&scoped=true"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"
import style0 from "./Other.vue?vue&type=style&index=0&id=2fb2aa33&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2aa33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb2aa33')) {
      api.createRecord('2fb2aa33', component.options)
    } else {
      api.reload('2fb2aa33', component.options)
    }
    module.hot.accept("./Other.vue?vue&type=template&id=2fb2aa33&scoped=true", function () {
      api.rerender('2fb2aa33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsList/components/Other.vue"
export default component.exports